// Tag-name normalization — the single definition every surface (API boundary,
// CLI, MCP, dashboard) must agree on, or 'Facturación', 'facturacion ' and
// 'facturacion' silently become three different tags and filtering misses.
// Rules: lowercase, trim, internal whitespace → '-', strip leading/trailing
// dashes, cap length. Unicode letters (accents, ñ) are preserved — tags are
// human labels in the team's language, not slugs.
export const MAX_TAG_LENGTH = 64

export function normalizeTag(raw: string): string {
  return raw
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_TAG_LENGTH)
}

// Normalize a list: map, drop empties, dedupe preserving first-seen order.
export function normalizeTags(raw: string[]): string[] {
  const out: string[] = []
  for (const r of raw) {
    const t = normalizeTag(r)
    if (t && !out.includes(t)) out.push(t)
  }
  return out
}
